import { useMutation } from '@tanstack/react-query';
import { notificationsApiService } from '../services/notificationsApi';
import type {
  UserNotificationSettings,
  UserNotificationUpdate,
} from '../types/notifications';

export const NotificationsQueryKeys = {
  notificationSettings: 'notification-settings',
};

interface UseNotificationsReturn {
  updateNotificationSettings: (
    settings: UserNotificationUpdate
  ) => Promise<UserNotificationSettings[]>;
  isUpdating: boolean;
  updateError: Error | null;
}

export const useNotifications = (): UseNotificationsReturn => {
  const updateNotificationSettingsMutation = useMutation({
    mutationFn: (settings: UserNotificationUpdate) =>
      notificationsApiService.updateNotificationSettings(settings),
  });

  return {
    updateNotificationSettings: updateNotificationSettingsMutation.mutateAsync,
    isUpdating: updateNotificationSettingsMutation.isPending,
    updateError: updateNotificationSettingsMutation.error,
  };
};
